// src/api/index.js
import axios from 'axios';
import { createAppTransport } from '@1823-partners/core';

// Same-origin proxy: SWA Function in production, CRA proxy (src/setupProxy.js)
// in local development. Zero credentials shipped in the bundle.
const api = createAppTransport({ axios, appName: 'blotter' });

// Entry API functions
export const fetchEntry = (entryId) => api.get(`/blotter-entry?entryId=${entryId}`);
export const fetchEntries = () => api.get('/blotter-entries');
export const saveEntry = (entry) => api.post('/save-entry', entry);
export const saveEntries = (entries) => api.post('/save-entries', entries);
export const deleteEntry = (entry) => api.post('/delete-entry', entry);
export const importBlotter = (entries) => api.post('/import-blotter', entries);

// Counterparty API functions
export const fetchCounterparties = () => api.get('/counterparties');
export const fetchCounterparty = (counterpartyId) => api.get(`/counterparty?cp_id=${counterpartyId}`);
export const saveCounterparties = (counterparties) => api.post('/save-counterparties', counterparties);
export const deleteCounterparty = (counterparty) => api.post('/delete-counterparty', counterparty);

// Override API functions
export const fetchOverride = (overrideId) => api.get(`/override-entry?overrideId=${overrideId}`);
export const fetchOverrideDates = () => api.get('/override-dates');
export const fetchOverrides = (asofdt) => api.get(`/override-entries?asofdt=${asofdt}`);
export const saveOverrides = (overrides) => api.post('/save-overrides', overrides);
export const deleteOverride = (override) => api.post('/delete-override', override);
export const bulkDeleteOverrides = (user, deleteRows) => api.post('/delete-overrides', { user, deleteRows });

// Holdings API functions
export const fetchHolding = (cusip, asofdt) => {
  const params = new URLSearchParams({ cusip });
  if (asofdt) {
    params.append('asofdt', asofdt);
  }
  return api.get(`/holdings-entry?${params.toString()}`);
};
export const fetchHoldingsDates = () => api.get('/holdings-dates');
export const fetchHoldings = (asofdt) => api.get(`/holdings-entries?asofdt=${asofdt}`);
export const fetchHoldingsView = (asofdt) => api.get(`/holdings-view?asofdt=${asofdt}`);
export const saveHoldings = (holdings) => api.post('/save-holdings', holdings);
export const deleteHoldings = (user, deleteRows) => api.post('/delete-holdings', { user, deleteRows });

export default api;
